module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/lang.1ea3f255.svg";